import type { CSSProperties } from 'react'
import type { Theme } from '@mui/material/styles'

export type DashboardTypographyStyle = {
  fontFamily: string
  fontSize: CSSProperties['fontSize']
  fontWeight: number
  lineHeight?: CSSProperties['lineHeight']
  letterSpacing?: CSSProperties['letterSpacing']
  textTransform?: CSSProperties['textTransform']
  fontVariantNumeric?: CSSProperties['fontVariantNumeric']
  color: CSSProperties['color']
  fill?: CSSProperties['fill']
}

const ensureFontFamily = (fallback: string, candidate?: string | number): string => {
  if (typeof candidate === 'string' && candidate.trim().length > 0) {
    return candidate
  }

  return fallback
}

export const dashboardCardHeadingTypography = (theme: Theme): DashboardTypographyStyle => {
  const base = theme.typography.subtitle2
  const color = theme.palette.text.secondary

  return {
    fontFamily: ensureFontFamily(theme.typography.fontFamily, base.fontFamily),
    fontSize: base.fontSize,
    fontWeight: 700,
    lineHeight: base.lineHeight,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color,
  }
}

export const dashboardCardValueTypography = (theme: Theme): DashboardTypographyStyle => {
  const base = theme.typography.h3
  const color = theme.palette.text.primary

  return {
    fontFamily: ensureFontFamily(theme.typography.fontFamily, base.fontFamily),
    fontSize: base.fontSize,
    fontWeight: (typeof base.fontWeight === 'number' ? base.fontWeight : undefined) ?? 600,
    lineHeight: base.lineHeight,
    letterSpacing: base.letterSpacing,
    fontVariantNumeric: 'tabular-nums',
    color,
    fill: color,
  }
}

